module.exports = __webpack_public_path__ + "static/media/pending_flag.7192ee1e.svg";